import { type ReactNode, useEffect } from 'react';

type ScrollToTopProps = {
  stepIndex: number;
  totalSteps: number;
  children?: ReactNode;
};

const ScrollToTop = ({ stepIndex, totalSteps, children }: ScrollToTopProps) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: we want it to run when these dependencies change
  useEffect(() => {
    if (window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
  }, [stepIndex, totalSteps]);

  return children;
};

export { ScrollToTop };
